/**
 * Copyright © Veeam Software Group GmbH.
 */

import { EProductUpgradeStatus as EProductUpgradeStatusModel } from '@veeam-vspc/models/web-controllers';

export type EProductUpgradeStatus = EProductUpgradeStatusModel;
export const EProductUpgradeStatus = EProductUpgradeStatusModel;
